/**
 * Affiliate Configuration
 * This file is auto-generated based on environment variables:
 * - AFFILIATE
 * - AFFILIATE_LINK
 *
 * Generated at: 2026-03-30T14:16:59.151Z
 */

// Affiliate brand name (used for logo filename and UI fallback)
export const AFFILIATE = 'TransDates'

// Direct affiliate URL (used for redirects / outbound)
export const AFFILIATE_LINK = 'https://t.crdtg3.com/345641/6497?bo=2753,2754,2755,2756&aff_sub5=SF_006OG000004lmDN'

export const AFFILIATE_LOGO_FILE = 'TransDates.png'

const affiliateConfig = { AFFILIATE, AFFILIATE_LINK, AFFILIATE_LOGO_FILE }
export default affiliateConfig
